export interface OrderSelector {
    value: Order;
    text: string;
}

export enum Order {
    ascending = 1,
    descending = 2
}